import Head from 'next/head';
import { AlternateLink } from '@bridebook/web/lib/types';
import { getRobotsNoIndexContent } from '@bridebook/web/lib/utils/seo';

export interface IProps {
  title?: string;
  description?: string | null;
  canonical: string;
  alternate: AlternateLink[];
  isMainLiveCDN: boolean;
}

/**
 * Returns next.js Head component for use with Webflow landing pages
 */
const LandingPagesHead = ({ canonical, alternate, isMainLiveCDN, title, description }: IProps) => (
  <Head>
    <title>{title}</title>
    {description && <meta name="description" content={description} />}
    {!isMainLiveCDN && <meta name="robots" content={getRobotsNoIndexContent(false)} />}
    {canonical && <link rel="canonical" href={canonical} />}
    {alternate.map(({ href, hrefLang }) => (
      <link rel="alternate" href={href} hrefLang={hrefLang} key={hrefLang} />
    ))}
    <meta
      content="viewport-fit=cover, width=device-width, height=device-height, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"
      name="viewport"
    />
    <link rel="preconnect" href="https://fonts.googleapis.com" />
    <link
      href="https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap"
      rel="stylesheet"
    />
  </Head>
);

export default LandingPagesHead;
